<div class="account-pages"></div>
<div class="clearfix"></div>
<div class="wrapper-page">
	<div class=" card-box">
		<div class="panel-heading text-center">
			<img src="img/samson_icon.png" alt=""></img>
			<h3>{{TR "Neues Passwort setzen"}}</h3>
		</div>
		<div class="panel-body">
			{{#if errors.error}}
			<div class="alert alert-danger">{{errors.error}}</div>
			{{/if}}
			<p>
			{{TR "Geben Sie ein neues Passwort ein."}}
			</p>
			<form class="form-horizontal m-t-20" action="#" method="post">
				<div class="form-group ">
					<div class="col-xs-12">
						<input id= "js-password-input" class="form-control {{#if errors.password}}parsley-error{{/if}}" type="password" name="password" placeholder="{{TR "Neues Passwort"}}" autocomplete="off">
						{{#if errors.password}}
						<ul class="parsley-errors-list filled" id="js-password-error">
							<li class="parsley-required">{{errors.password}}</li>
						</ul>
						{{/if}}
					</div>
				</div>
				<div class="form-group text-center m-t-40">
					<div class="col-xs-12">
						<button class="js-set btn btn-pink btn-block text-uppercase" type="submit">
							{{TR "Setzen"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
